module.exports = __webpack_public_path__ + "static/img/包装设计-礼盒设计.c3cfccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10004/包装设计-礼盒设计.png
// module id = g74R
// module chunks = 1